import { render, staticRenderFns } from "./Exemptions.vue?vue&type=template&id=ddede756"
import script from "./Exemptions.vue?vue&type=script&lang=js"
export * from "./Exemptions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports